import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { connectStateResults } from 'react-instantsearch-dom';
import Link from '../../utils/link';
import Typography from '../../atoms/typography';
import CMSModuleProducts from '../../organisms/algolia-cms/cms-module-products';

const Container = styled.section`
  font-family: ${(props) => props.theme.font.sans};
  font-size: 1.4rem;
  text-align: center;
  width: 100%;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {
    display: flex;
    text-align: left;
  }
`;

const Label = styled(Typography)`
  align-items: baseline;
  color: ${(props) => props.theme.color.brand};
  display: inline-flex;
  text-transform: uppercase;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {
    padding-right: 20px;
    flex: 0 1 auto;
  }
`;

const Products = styled.ul`
  align-items: baseline;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1 1 auto;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {
    flex-direction: row;
  }
`;

const ProductLink = styled.li`
  a {
    color: ${(props) => props.theme.color.brandLight};
    cursor: pointer;
    text-decoration: none;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {
    padding-right: 12px;
  }
`;

const ModuleProducts = connectStateResults((props) => {
  const products = props.searchResults?.hits;
  return products?.length > 0 ? products.map((product) => (
    <ProductLink key={product?.product_slug ?? product.slug}>
      <Link href={`/product/${product?.product_slug ?? product.slug}`} passHref>
        <a>
          { `${product.title}${product.brand ? `, ${product.brand}` : ''};` }
        </a>
      </Link>
    </ProductLink>
  )) : null;
});

const ProductText = (props) => (
  <Container>
    <Label element="h3" like="dec-1">Shop</Label>
    <Products>
      <CMSModuleProducts products={props.products}>
        <ModuleProducts />
      </CMSModuleProducts>
    </Products>
  </Container>
);

ProductText.propTypes = {
  products: PropTypes.object.isRequired
};

export default ProductText;
